import gql from "graphql-tag";

export const CREATE_QUOTE = gql`
  mutation AddQuote($data: QuoteDataInput) {
    addQuote(data: $data) {
      id
    }
  }
`;

export const SEND_QUOTE = gql`
  mutation sendQuote($data: QuoteDataInput) {
    sendQuote(data: $data) {
      id
    }
  }
`;

const quotes = { SEND_QUOTE };

export default quotes;
